export default __webpack_public_path__ + "static/media/BG-Red-0003.cd74c228.png";